export const FETCH_MAINTENANCE_ALERTS_LIST: string = 'FETCH_MAINTENANCE_ALERTS_LIST';
export const FETCH_MAINTENANCE_ALERTS_LIST_SUCCESS: string = 'FETCH_MAINTENANCE_ALERTS_LIST_SUCCESS';
export const FETCH_MAINTENANCE_ALERTS_LIST_ERROR: string = 'FETCH_MAINTENANCE_ALERTS_LIST_ERROR';
export const RESET_MAINTENANCE_ALERTS_LIST: string = 'RESET_MAINTENANCE_ALERTS_LIST';
export const ALERT_LIST_PREF_KEY: string = 'fleetLocate.alertList';
export type AlertListTypeAction = {
    type: string;
    payload?: Object;
};
